import { OverlayTrigger, Tooltip } from "react-bootstrap"

import styles from "./TableOptions.module.css"

interface IconOptionProps {
  icon: React.ReactNode
  onClick: () => void
  settings?: boolean
  deleteMod?: boolean
  disabled?: boolean
  tooltip?: string
  bold?: boolean
}

export default function IconOption({
  icon,
  onClick,
  settings,
  deleteMod,
  disabled,
  tooltip = "",
  bold,
}: IconOptionProps) {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <div
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
          ...(bold ? { border: "2px solid #b7bbc1" } : {}),
        }}
        className={`${styles.icon_option}  ${settings && styles.settings} ${deleteMod && styles.delete}`}
        onClick={() => !disabled && onClick()}
      >
        {icon}
      </div>
    </OverlayTrigger>
  )
}
